import { gql } from '@apollo/client';

export * from './beneficiaryCertificateAssetCount.query.generated';

export const BENEFICIARY_CERTIFICATE_ASSET_COUNT = gql`
  query beneficiaryCertificateAssetCount(
    $softwareEscrowId: ID!
    $contentType: AssetContentTypeEnum
    $labeled: Boolean
  ) {
    beneficiaryCertificateAssetCount(
      softwareEscrowId: $softwareEscrowId
      contentType: $contentType
      labeled: $labeled
    ) {
      count
      latestDeposit
    }
  }
`;
